import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics, trackWebVitals } from './utils/analytics';

// Listen for service worker updates and force refresh when needed
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'CACHE_UPDATED') {
      console.log('🔄 Service worker updated, refreshing page...');
      // Force reload to get latest version
      window.location.reload();
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize analytics with automatic tracking (geo, device, performance)
initAnalytics('G-1R9LQJZMX6');

// Send Web Vitals to analytics
reportWebVitals(trackWebVitals);
